export const CRMProject = [
    {
      "id": 6,
      "project_name": "iBizAccounts",
      "customer": "Perennial Developers",
      "tags": ["Finance", "Accounting"],
      "start_date": "26/05/2022",
      "deadline": "26/05/2025",
      "members": ["John Doe", "Jane Smith", "Alice Johnson", "Michael Brown"],
      "status": "In Progress"
    },
    {
      "id": 24,
      "project_name": "TATA Projects",
      "customer": "Prudent Teqtis Pvt Ltd",
      "tags": ["Construction", "Infrastructure"],
      "start_date": "07/12/2024",
      "deadline": "07/06/2026",
      "members": ["Robert White", "Sophia Lee", "David Miller", "Emily Davis"],
      "status": "In Progress"
    },
    {
      "id": 23,
      "project_name": "Giivv.com",
      "customer": "MetroMedi",
      "tags": ["E-commerce", "Healthcare"],
      "start_date": "28/11/2024",
      "deadline": "28/05/2026",
      "members": ["Daniel Wilson", "Emma Thomas", "James Martin", "Olivia Harris"],
      "status": "In Progress"
    },
    {
      "id": 22,
      "project_name": "PereCo",
      "customer": "Perennial Developers",
      "tags": ["Real Estate", "Development"],
      "start_date": "01/12/2024",
      "deadline": "01/12/2026",
      "members": ["William Anderson", "Charlotte Garcia", "Benjamin Martinez", "Mia Robinson"],
      "status": "In Progress"
    },
    {
      "id": 21,
      "project_name": "Marketplace",
      "customer": "Suntek Systems",
      "tags": ["E-commerce", "Technology"],
      "start_date": "15/05/2024",
      "deadline": "15/11/2025",
      "members": ["Alexander Clark", "Amelia Rodriguez", "Mason Lewis", "Harper Walker"],
      "status": "In Progress"
    },
    {
      "id": 20,
      "project_name": "Internal",
      "customer": "Perennial Developers",
      "tags": ["Internal Project", "Operations"],
      "start_date": "15/11/2023",
      "deadline": "15/11/2025",
      "members": ["Elijah Hall", "Scarlett Allen", "Logan Young", "Avery King"],
      "status": "In Progress"
    }
  ]
  